var amt_admin = require('amt_admin').default;
var app = require("angular").module("ww2_analytics.admin_migration", [
  amt_admin
]);

app.service("migration_api", [
  "jsonrpc",
  function(jsonrpc) {
    var service = jsonrpc.newService("migration");
    this.migration_status = service.createMethod("migration_status");
    this.get_global_migration_tasks = service.createMethod(
      "get_global_migration_tasks"
    );
    this.global_migration_task_stop = service.createMethod(
      "global_migration_task_stop"
    );
    this.global_migration_task_delete = service.createMethod(
      "global_migration_task_delete"
    );
    this.global_migration_subtask_stop = service.createMethod(
      "global_migration_subtask_stop"
    );
    this.global_migration_consume = service.createMethod(
      "global_migration_consume"
    );
    this.global_migration_task = service.createMethod("global_migration_task");
    this.global_migration_delete_temp_table = service.createMethod(
      "global_migration_delete_temp_table"
    );
  }
]);

var migration_tpl = require("./migration.html");
var migration_status_tpl = require("./migration_status.html");

app.config([
  "$stateProvider",
  function($stateProvider) {
    $stateProvider
      .state("amt.ww2.admin.migration", {
        url: "/migration",
        template: migration_tpl,
        data: {
          priority: 0,
          title: "Migration",
          role: "admin",
          hidden_filters: true
        },
        resolve: {
          tasks: [
            "migration_api",
            function(migration_api) {
              return migration_api.get_global_migration_tasks({});
            }
          ]
        },
        controller: [
          "$scope",
          "tasks",
          "migration_api",
          function($scope, tasks, migration_api) {
            $scope.tasks = tasks;
            $scope.start = function(model) {
              migration_api.global_migration_task({
                tables: model.tables,
                date_from: model.date_from,
                date_to: model.date_to,
                request_batch: model.request_batch,
                insert_batch: model.insert_batch
              });
            };
            $scope.stop_task = function(task_id) {
              migration_api.global_migration_task_stop({ task_id: task_id });
            };
            $scope.delete_task = function(task_id) {
              migration_api.global_migration_task_delete({ task_id: task_id });
            };
            $scope.stop_subtask = function(task_id, subtask_id) {
              migration_api.global_migration_subtask_stop({
                task_id: task_id,
                subtask_id: subtask_id
              });
            };
            $scope.consume = function(task_id, table_name) {
              migration_api.global_migration_consume({
                task_id: task_id,
                table_name: table_name
              });
            };
            $scope.delete_temp_table = function(task_id, table_name) {
              migration_api.global_migration_delete_temp_table({
                task_id: task_id,
                table_name: table_name
              });
            };
          }
        ]
      })
      .state("amt.ww2.migration_status", {
        url: "/migration_status",
        template: migration_status_tpl,
        data: {
          priority: 0,
          title: "Migration Status",
          role: "admin",
          hidden_filters: true
        },
        resolve: {
          migration_status: [
            "migration_api",
            function(migration_api) {
              return migration_api.migration_status({});
            }
          ]
        },
        controller: [
          "$scope",
          "migration_status",
          function($scope, migration_status) {
            $scope.migration_status = migration_status;
          }
        ]
      });
  }
]);

export default app.name;
